import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  user: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
    },
    updateToken: (state, action) => {
      state.token = action.payload.token;
    },
    updateIsVerfied:(state, action)=>{
      state.user = action.payload
    }
  },
});

export const {
  loginSuccess,
  logout,
  updateToken,
  updateIsVerfied,
} = authSlice.actions;
export default authSlice.reducer;
